import { cn } from '@/lib/utils';

interface RiskBadgeProps {
  risk: 'LOW' | 'MEDIUM' | 'HIGH' | 'EXTREME';
  className?: string;
}

export function RiskBadge({ risk, className }: RiskBadgeProps) {
  const styles = {
    LOW: 'risk-low',
    MEDIUM: 'risk-medium',
    HIGH: 'risk-high',
    EXTREME: 'bg-purple-100 text-purple-700 border border-purple-200',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium',
        styles[risk],
        className
      )}
    >
      {risk}
    </span>
  );
}
